import * as React from 'react';
import { items } from '@wg/wows-entities/const';
import styles from './CommonRewardsLayout.scss';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import ChanceLabel from '~/components/ChanceLabel/ChanceLabel';
import classNames from 'classnames';
import PortPreviewButton from '~/components/PortPreviewButton/PortPreviewButton';
import { openPortByItem } from '~/settings/port';
import { PortPreviewType } from '~/components/Port/settings';
import { settings } from '~/utils/settings';
import { useDispatch } from 'react-redux';
import store from '~/Store';
import { POPUPS_NAME } from '~/components/PopupManager';
import { appActions } from '~/Store/appSlice';

interface ICommonReward {
    reward: ILootboxReward;
    className?: string;
    chanceLabelClassName?: string;
    inventoryCount?: number;
    bundleId?: number;
    isAvailablePortPreview?: boolean;
    lootboxId: number;
    useShortTitle?: boolean;
}

const CommonReward = React.memo(({ reward, className, chanceLabelClassName, inventoryCount, bundleId, isAvailablePortPreview, lootboxId, useShortTitle }: ICommonReward) => {
    const dispatch = useDispatch();

    const openPort = () => {
        dispatch(appActions.changeVisibilityPopup({ name: null }));
        openPortByItem({
            item: {
                shipId: settings.camouflagePreviewDefaultShip,
                type: reward.type,
                identifier: reward.id,
            },
            bundleId,
            portPreviewType: PortPreviewType.CONTAINER,
            additionalData: { lootboxId },
        });
    };

    const DescriptionPopupWrapper = ({ children }: { children: any }) => {
        if (reward.type === items.LOOTBOX) {
            const onClick = () => {
                store.dispatch(
                    appActions.changeVisibilityPopup({
                        name: POPUPS_NAME.ITEM_DESCRIPTION_POPUP,
                        isVisible: true,
                        data: {
                            item: {
                                identifier: reward.id,
                                type: reward.type,
                            },
                            autoDescriptionSettings: {},
                        },
                    }),
                );
            };
            return (
                <div onClick={onClick} className={classNames(styles.wowsEntity, styles.wowsEntityClickable)}>
                    {children}
                </div>
            );
        }

        return children;
    };

    return (
        <div className={classNames(styles.item, className)}>
            {isAvailablePortPreview && <PortPreviewButton onlyIcon className={styles.portPreviewButton} onClick={openPort} />}
            <DescriptionPopupWrapper>
                <WoWSEntity
                    id={reward.id}
                    type={reward.type}
                    className={styles.wowsEntity}
                    amount={reward.amount}
                    presentation={{
                        withTooltip: true,
                        withText: useShortTitle !== undefined ? !useShortTitle : true,
                        iconPosition: 'left',
                        renderWithoutFade: true,
                    }}
                    customisation={{
                        inventoryCount: inventoryCount,
                    }}
                />
            </DescriptionPopupWrapper>
            <ChanceLabel chance={reward.probabilityDisplayed} className={classNames(styles.changeLabel, chanceLabelClassName)} />
        </div>
    );
});

export default CommonReward;
